export default "__VITE_ASSET__CC6GD5SX__"